import React from 'react';

import { GridValidRowModel } from '@mui/x-data-grid';

import ActionCell, { ActionConfig } from 'components/Grid/components/ActionCell';

interface Props {
  rowData: GridValidRowModel;
}

const TeamDetailsActionCell: React.FC<Props> = ({ rowData }) => {
  const actions: ActionConfig[] = [
    {
      id: 'remove-button',
      label: 'Remove',
      onClick: async () => {
        rowData.removeMember();
      },
    },
  ];

  return <ActionCell actions={actions} recordName={rowData.name} />;
};

export default TeamDetailsActionCell;
